const welcomeBackMessageText = (userInfo) => {return (
`👋 Welcome back, ${userInfo.firstName}! Ready to keep shaping your RFP?
If you want to pick up where we left off, I’ve got everything right here.

Or, if anything’s changed — like your goals, timeline, or scope — just let me know and we’ll adjust as needed.`
)}

export const welcomeBackMessage = (userInfo) =>{return ({ role: "model", parts: [{ text: welcomeBackMessageText(userInfo)}] })};